/**
 * Cancels in-flight Axios requests when workspace/context changes by rotating a shared AbortController.
 */

let hubAbort = new AbortController()

export function getHubAbortSignal(): AbortSignal {
  return hubAbort.signal
}

/**
 * Cancels pending requests wired with this hub's signal then opens a fresh controller for new requests.
 */
export function cancelAllInFlightRequests(_reason?: string): void {
  hubAbort.abort()
  hubAbort = new AbortController()
}

function combineSignals(a: AbortSignal, b?: AbortSignal | null): AbortSignal {
  if (!b || b.aborted) return a
  if (!a.aborted && typeof AbortSignal !== 'undefined' && 'any' in AbortSignal && typeof (AbortSignal as any).any === 'function') {
    try {
      return (AbortSignal as any).any([a, b])
    } catch {
      /* fallthrough */
    }
  }
  const combo = new AbortController()
  const onAbort = () => combo.abort()
  if (a.aborted || b.aborted) {
    combo.abort()
    return combo.signal
  }
  a.addEventListener('abort', onAbort)
  b.addEventListener('abort', onAbort)
  return combo.signal
}

/** Merge Axios caller signal with rotating hub signal (caller wins if already aborted hub). */
export function mergeAbortSignal(existing?: AbortSignal): AbortSignal {
  const hub = getHubAbortSignal()
  return combineSignals(hub, existing ?? undefined)
}
